<mat-card appearance="outlined">
  <mat-card-header>
    <h3 data-test-id="schedule-add-available-times-title">
      Add available times
    </h3>
  </mat-card-header>
  <mat-card-content>
    <app-schedule-add-available-times-form
      [allowWeekends]="allowWeekends()"
      [defaultTimezoneName]="timezoneName()"
      [disabled]="disabled()"
      (addTimes)="addTimes.emit($event)"
    />
  </mat-card-content>
</mat-card>
